import { AlphaDBoxIcon } from './AlphaDBoxIcon';

/**
 * author: GreenTurtwig
 * id 5299B671-D7CF-4D68-B439-92E3056A104A
 * name alpha-d-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-d-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetDBoxIcon = AlphaDBoxIcon;
export default AlphabetDBoxIcon